import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { minutos: Number }
  static targets = ["minutos"]

  connect() {
    if (this.minutosValue > 0) {
      this.segundosRestantes = this.minutosValue * 60
      this.timerId = setInterval(() => this.tick(), 1000)
    }
  }

  tick() {
    this.segundosRestantes--
    const minutosAtuais = Math.ceil(this.segundosRestantes / 60)
    if (this.hasMinutosTarget) {
      this.minutosTarget.textContent = minutosAtuais
    }

    if (this.segundosRestantes <= 0) {
      clearInterval(this.timerId)
      this.timerId = null
      // Recarrega para mostrar estado atualizado (botão disponível)
      window.location.reload()
    }
  }

  disconnect() {
    if (this.timerId) {
      clearInterval(this.timerId)
      this.timerId = null
    }
  }
}
